/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestStepLogBaseParser = /* #__PURE__ */ parsers.object([]);
export class AutoTestStepLogBase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestStepLogBaseParser.decode(input).map(res => new AutoTestStepLogBase(res));
    }
    static unsafeDecode(input) {
        return AutoTestStepLogBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestStepLogBaseParser.encode(data);
    }
    static schema() {
        return AutoTestStepLogBaseParser.schema();
    }
}
